/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TourTypeEnum } from './tourTypeEnum';
import { TourStatusEnum } from './tourStatusEnum';


export interface TourResource { 
    id: number;
    type: TourTypeEnum;
    status: TourStatusEnum;
    userId: number | null;
    userEmail: string | null;
    externalUserId: number | null;
    data: string;
    completedAt: string | null;
    createdAt: string | null;
    updatedAt: string | null;
}
export namespace TourResource {
}


